<div class="mcv_banner">
    <table class="width-100 no-border">
        <caption class="sr-only">{{'MCVHEADER.TABLE_CAPTION' | translate}}</caption>
        <thead>
            <tr>
                <th class="mcv_banner_field bold-weight small" style="width: 6%;"></th>
                <th class="mcv_banner_field bold-weight small" style="width: 9%;">{{'MCVHEADER.CLIENT_NAME' | translate}}</th>
                <th class="mcv_banner_field bold-weight small" style="width: 18%;">{{'MCVHEADER.CLIENT_NAME' | translate }}</th>
                <th class="mcv_banner_field bold-weight small" style="width: 6%;">{{'MCVHEADER.USER_ID' | translate}}</th>
                <th class="mcv_banner_field bold-weight small" style="width: 18%;">{{'MCVHEADER.USER_ID' | translate }}</th>
                <th class="mcv_banner_field bold-weight small" style="width: 10%;">{{'MCVHEADER.SUSCRIBER_ID' | translate}}</th>
                <th *ngIf="loginId !== ''" class="mcv_banner_field bold-weight small" style="width: 18%;">{{ loginId | translate }}</th>
                <th *ngIf="loginId === ''" class="mcv_banner_field bold-weight small" style="width: 18%;">{{ subscriberId | translate }}</th>
                <th class="mcv_banner_field bold-weight small" style="width: 15%;">
                    <input 
                        name="Submit" 
                        type="submit" 
                        class="TextBlackNormal button" 
                        [value]="'MCVHEADER.LOGOUT' | translate" 
                        (click)="onLogoutClick()">
                </th>
            </tr>
        </thead>
    </table>
</div> 
